import { Injectable } from '@angular/core';
import { PageType, PageVersionStoreModel } from '@examdojo/category/v2';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { PageVersionBrowserComponent } from './page-version-browser.component';

export const PAGE_VERSION_BROWSER_DIALOG_ID = 'page-version-browser';

export interface PageVersionBrowserDialogInput {
  pageType: PageType;
  activeId?: PageVersionStoreModel['id'];
}

export type PageVersionBrowserDialogOutput = PageVersionStoreModel['id'] | undefined;

@Injectable()
export class PageVersionBrowserDialogService extends AbstractDialogService<
  PageVersionBrowserDialogInput,
  PageVersionBrowserDialogOutput
> {
  readonly id = PAGE_VERSION_BROWSER_DIALOG_ID;
  protected readonly component = PageVersionBrowserComponent;

  override openDialog({ input }: { input: PageVersionBrowserDialogInput }) {
    return super.openDialog({
      options: {
        ...this.options,
        cssClass: 'modified-modal',
        componentProps: { pageType: input.pageType, activeId: input.activeId },
      },
    });
  }
}
